import { indexedDB } from "./indexedDB";
export const resetStorage = {
  set: () => {},
  get: () => null,

  async remove(key) {
    sessionStorage.removeItem(key);
    await indexedDB.remove(key);
  }

};